/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Transaction server Services 
 * These services provide APIs to interact with transaction
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ComIbmCommerceMarketingFacadeDatatypesAreaTypeUserData } from './com-ibm-commerce-marketing-facade-datatypes-area-type-user-data';

/**
 * 
 * @export
 * @interface ComIbmCommerceMarketingFacadeDatatypesAreaType
 */
export interface ComIbmCommerceMarketingFacadeDatatypesAreaType {
    /**
     * 
     * @type {ComIbmCommerceMarketingFacadeDatatypesAreaTypeUserData}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    userData?: ComIbmCommerceMarketingFacadeDatatypesAreaTypeUserData;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    target?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    url?: string;
    /**
     * 
     * @type {number}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    displaySequence?: number;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    coordinates?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    shape?: ComIbmCommerceMarketingFacadeDatatypesAreaTypeShapeEnum;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    uniqueID?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommerceMarketingFacadeDatatypesAreaType
     */
    alternateText?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ComIbmCommerceMarketingFacadeDatatypesAreaTypeShapeEnum {
    Rect = 'rect',
    Circle = 'circle',
    Poly = 'poly'
}



